import { ArrowRight } from "lucide-react";

import { URLS } from "@/config/domains";

import { MarketingButton } from "./ui/MarketingButton";
import { MarketingContainer } from "./ui/MarketingContainer";

export function CTASection() {
  return (
    <section className="relative overflow-hidden py-24">
      <div className="absolute left-1/2 top-1/2 -z-10 h-80 w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-600/20 blur-[140px]" />

      <MarketingContainer>
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-300">
            Start Your Pilot
          </p>

          <h2 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-6xl">
            Ready to better understand your congregation?
          </h2>

          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-slate-400">
            Join the MinistryIQ pilot and discover how clearer
            engagement insights can help your ministry team care
            for people more intentionally.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <MarketingButton
              href="/request-access"
              className="w-full sm:w-auto"
            >
              Request Pilot Access
              <ArrowRight className="ml-2 h-4 w-4" />
            </MarketingButton>

            <MarketingButton
              href={`${URLS.church}/app/login`}
              variant="secondary"
              className="w-full sm:w-auto"
            >
              Church Login
            </MarketingButton>
          </div>
        </div>
      </MarketingContainer>
    </section>
  );
}
